export default {"src":"/_next/static/media/yunexpress.51b64906.svg","height":512,"width":512};